import request from '@/utils/request';

interface IThumbnail {
    width: number;
    height: number;
    url: string;
}

export type FontMaterialRaw = {
    type: 'fonts';
    category_id: number;
    category_name: string;
    corner_mark: {
        height: number;
        url: string;
        width: number;
    };
    corner_mark_id: number;
    default_name: string;
    extra: string;
    font_file: {
        url: string;
    };
    font_name: string;
    id: number;
    status: number;
    threshold: number;
    thumbnail: IThumbnail;
    thumbnail_text_dark: {
        url: string;
    };
    thumbnail_text_white: {
        url: string;
    };
    type_id: number;
    woff2_file: {
        url: string;
    };
    zip_file: {
        url: string;
    };
    font_group_name: string;
    font_weight_value: number;
    font_metrics: string;
    font_group_thumbnail_dark: {
        url: string;
    };
    font_group_thumbnail_white: {
        url: string;
    };
};

export interface FontItem {
    // 分类ID
    category_id: number;
    // 分类名称
    category_name: string;
    // 字体素材iD
    id: number;
    /** 字体名称（font-family） */
    font_name: string;
    /** 字体显示名称 */
    name: string;
    is_vip: string;
    material_id: number;
    thumbnail: string;
    thumbnail_text_dark: string;
    thumbnail_text_white: string;
    // zip包地址
    zip_file: string;
    zip_url: string;
    font_file: string;
    /** 会员角标 */
    corner_mark: string;
    threshold: number;
    type_id: number;
    woff2_file_url?: string;
    font_group_name: string;
    font_weight_value: number;
    font_group_thumbnail_white: string;
    font_group_thumbnail_dark: string;
}

export type FontsCategoriesRaw = {
    category_id: number;
    category_name: string;
    materials: FontMaterialRaw[];
}[];

export const fetchFontList = async (opts?: { onlyFetchTeamFonts?: boolean }): Promise<FontsCategoriesRaw> =>
    request.get<any, FontsCategoriesRaw>('/v1/category/fonts_list', {
        params: {
            type: 'fonts',
            only_team: opts?.onlyFetchTeamFonts ? 1 : 0,
        },
    });

interface ISearchParams {
    keyword: string;
    count?: number;
    /**
     * haibaopai:模板搜索
     * pic_static_sticker:贴纸搜索
     */
    type: string;
    /**
     * 当type = pic_static_sticker 时,且涉及到标签颜色搜索是必传
     */
    filter?: string;
    client_id?: string;
    version?: string;
    gid?: string;
    preview_mode?: string;
}

/**
 * 接口 [↗](/v1/search/font)
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/149421
 */
export const searchFonts = async (params: ISearchParams) =>
    await request.get<any, FontsCategoriesRaw>('/v1/search/font', { params });
